export const API_URL = {
  // ------ START: Auth URL's ------
  signin: "/authentication-service/v1/login",
  getMe: "/auth/v1/profile/get-me",
  uploadFile: "/auth/v1/upload-file",
  uploadMobileToken: "/auth/v1/profile/update-mobile-token",

  // ------ START: Vendor URL's ------
  createVendor: "/vendors/v1/create",
  updateVendor: "/vendors/v1/update-vendor",
  archiveVendor: "/vendors/v1/archive",
  getVendorList: "/vendors/v1/list",
  getVendorDetails: "/vendors/v1/details",
  deleteVendorPaymentInfo: "/vendors/v1/delete-payment-info",
  setDefaultPaymentInfo: "/vendors/v1/set-default-payment-info",
  updateDefaultPaymentInfo: "/vendors/v1/update-payment-info",
  getVendorActivityLog: "/vendors/v1/vendor-activity",

  // ------ START: Service Type URL's ------
  createServiceType: "/vendors/v1/service-type/create",
  updateServiceType: "/vendors/v1/service-type/update",
  getServiceTypeList: "/vendors/v1/service-type/get/all",

  // ------ START: Bank URL's ------
  getBankList: "/invoices/v1/get-banks-keywords",

  // ------ START: Invoice URL's ------
  createInvoice: "/invoices/v1/create-invoice",
  updateInvoice: "/invoices/v1/update-invoice",
  archiveInvoice: "/invoices/v1/archive",
  sendToApprover: "/invoices/v1/send-to-approvers",
  approveInvoice: "/invoices/v1/approve",
  rejectInvoice: "/invoices/v1/reject",
  sendToDisbursement: "/invoices/v1/send-for-disbursement",
  getInvoiceList: "/invoices/v1/get-invoices",
  getInvoiceDetails: "/invoices/v1/get-invoice-by-id",
  getWaitingForApprovalInvoiceList: "/invoices/v1/for-approval",
  getPaymentsInvoiceList: "/invoices/v1/payment-status",

  // ------ START: Business Unit URL's ------
  getBusinessUnitList: "/business-unit/v1/all",
  getDepartmentList: "/departments/v1/all",

  // ------ START: Dashboard URL's ------
  getDueAmount: "/dashboard/v1/due-amounts",
  getSummery: "/dashboard/v1/summary",
  getMonthlyPaidInvoiceData: "/dashboard/v1/monthly-paid-invoices",
  getTopFiveVendors: "/dashboard/v1/top-vendors-raw",
  getPayableDates: "/dashboard/v1/payable-dates",
  getDateWiseAmount: "/dashboard/v1/date-wise-amounts",
};
